(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabecalho"] && !window.DesignMode) return;
  try {
    
  function closeSearch() {
    $('.e-header__search-results').removeClass('e-active');
    $('body').removeClass('overflow-hidden');
    $('[data-js="e-search-bar-input"]').val('');
    $('[data-js="e-search-bar-input"]').trigger('input');
  }

  window.closeSearch = closeSearch;

  function searchDefault() {
    let timer;

    $('.e-header__content--search-container img').click(() => {
      $('.e-header__content--search-container').removeClass('e-hidden');
      $('[data-js="e-search-bar-input"]').focus();
    });

    $('.e-header__content--search .e-header__content--search-container-close').click(() => {
      $('.e-header__search-results').removeClass('e-active');
      $('body').removeClass('lock-scroll');
      $('.e-header__content--search-container').addClass('e-empty');
      $('[data-js="e-search-bar-input"]').val('');
      $('[data-js="e-search-bar-input"]').trigger('input');
    });

    $('.e-header__content--icons-search').click(() => {
      $('.e-search-bar__mobile').removeClass('e-hidden');
      $('.e-search-bar__mobile [data-js="e-search-bar-input"]').focus();
    });

    $('.e-search-bar__mobile .e-header__content--search-container-close').click(() => {
      $('.e-header__search-results').removeClass('e-active');
      $('body').removeClass('lock-scroll');
      $('.e-search-bar__mobile').addClass('e-hidden');
      $('.e-search-bar__mobile').addClass('e-empty');
      $('[data-js="e-search-bar-input"]').val('');
      $('[data-js="e-search-bar-input"]').trigger('input');
    });

    async function searchBox(event) {
      const term = event.target.value;

      const responseProducts = await $.ajax({
        url: `/search?view=ajax&q=${term}&type=product`,
        type: 'GET',
        contentType: 'application/json',
      });

      const responseArticles = await $.ajax({
        url: `/search?view=ajax&q=${term}&type=article`,
        type: 'GET',
        contentType: 'application/json',
      });

      if (term == '') {
        $('.e-header__search-results').removeClass('e-active');
        $('body').removeClass('lock-scroll');
        $('#e-search-results .e-header__search-results--products').html('');
        $('#e-search-results--mobile .e-header__search-results--products').html('');
      } else {
        $('.e-header__search-results').addClass('e-active');
        $('body').addClass('lock-scroll');
        $('#e-search-results .e-header__search-results--products').html(responseProducts);
        $('#e-search-results--mobile .e-header__search-results--products').html(responseProducts);
      }
    }

    $('[data-js="e-search-bar-input"]').on('input', (event) => {
      const term = event.target.value;
      if (term == '') {
        $('.e-header__content--search-container').addClass('e-empty');
        $('.e-search-bar__mobile').addClass('e-empty');
        document.body.classList.remove('overflow-hidden');
      } else {
        document.body.classList.add('overflow-hidden');
        $('.e-header__content--search-container').removeClass('e-empty');
        $('.e-search-bar__mobile').removeClass('e-empty');
      }

      clearTimeout(timer);
      timer = setTimeout(() => {
        searchBox(event);
      }, 400);
    });
  }
  searchDefault();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-produtos"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('load', () => {
    const itens = $('.d-carousel-produtos .d-carousel-produtos__list--carousel .d-carousel-produtos__list-item');

    if (itens.length > 1 && $(window).width() >= 1024) {
      $('.d-carousel-produtos .d-carousel-produtos__list--carousel')
        .not('.slick-initialized')
        .slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          dots: false,
          arrows: true,
          infinite: false,
          center: false,
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/></svg></button>',
          responsive: [
            {
              breakpoint: 670,
              settings: {
                slidesToShow: 2,
                dots: false,
              },
            },
            {
              breakpoint: 425,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
    } else {
      $('.d-carousel-produtos .d-carousel-produtos__list').addClass('d-carousel-produtos__list--grid');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-lateral"] && !window.DesignMode) return;
  try {
    
  const menuLateral = document.querySelector('.d-menu-lateral');
  const cabecalhoBotaoMenuLateral = document.querySelector('.d-cabecalho-menu-hambuguer');
  const botaoFecharMenuLateral = document.querySelector('.d-menu-lateral__close');

  cabecalhoBotaoMenuLateral.addEventListener('click', (event) => {
    document.body.classList.add('overflow-hidden');
    menuLateral.classList.add('d-menu-lateral--active');
  });

  botaoFecharMenuLateral.addEventListener('click', (event) => {
    document.body.classList.remove('overflow-hidden');
    menuLateral.classList.remove('d-menu-lateral--active');
  });

  const accordionHeaders = document.querySelectorAll('.d-menu-lateral__list-item-title');

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
      abrirAccordion();
      accordionHeaders.forEach((header) => {
        header.removeEventListener('click', abrirFecharAccordion);
      });
    } else if (window.innerWidth < 1024) {
      accordionHeaders.forEach((header) => {
        header.addEventListener('click', abrirFecharAccordion);
        const content = header.nextElementSibling;
        header.classList.remove('active');
        if (content) {
          content.style.maxHeight = null;
          content.classList.remove('active');
        }
      });
    }
  });

  if (window.innerWidth >= 1024) {
    abrirAccordion();
    accordionHeaders.forEach((header) => {
      header.removeEventListener('click', abrirFecharAccordion);
    });
  } else if (window.innerWidth < 1024) {
    accordionHeaders.forEach((header) => {
      header.addEventListener('click', abrirFecharAccordion);
    });
  }

  function abrirFecharAccordion() {
    this.classList.toggle('active');
    const content = this.nextElementSibling;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.classList.remove('active');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.add('active');
    }
  }

  function abrirAccordion() {
    accordionHeaders.forEach((header) => {
      header.classList.add('active');
      const content = header.nextElementSibling;
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rodape"] && !window.DesignMode) return;
  try {
    
  const accordionHeaders = document.querySelectorAll('.d-rodape__menu-container--list-item-title');

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
      abrirAccordion();
      accordionHeaders.forEach((header) => {
        header.removeEventListener('click', abrirFecharAccordion);
      });
    } else if (window.innerWidth < 1024) {
      accordionHeaders.forEach((header) => {
        header.addEventListener('click', abrirFecharAccordion);
        const content = header.nextElementSibling;
        if (content) {
          content.style.maxHeight = null;
          content.classList.remove('active');
        }
        header.classList.remove('active');
      });
    }
  });

  if (window.innerWidth >= 1024) {
    abrirAccordion();
    accordionHeaders.forEach((header) => {
      header.removeEventListener('click', abrirFecharAccordion);
    });
  } else if (window.innerWidth < 1024) {
    accordionHeaders.forEach((header) => {
      header.addEventListener('click', abrirFecharAccordion);
    });
  }

  function abrirFecharAccordion() {
    this.classList.toggle('active');
    const content = this.nextElementSibling;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.classList.remove('active');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.add('active');
    }
  }

  function abrirAccordion() {
    accordionHeaders.forEach((header) => {
      header.classList.add('active');
      const content = header.nextElementSibling;
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
